var _rect, _rect2, _rect3, _rect4, _rect5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTowerOfLondon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 24,
    width: 8,
    height: 56,
    rx: 4,
    fill: "#FAC1B5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 76,
    width: 48,
    height: 8,
    rx: 4,
    fill: "#C75E5A"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 62,
    width: 44,
    height: 12,
    rx: 6,
    fill: "#C75E5A"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 48,
    width: 34,
    height: 12,
    rx: 6,
    fill: "#F9907B"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 34,
    width: 24,
    height: 12,
    rx: 6,
    fill: "#FAC1B5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTowerOfLondon);
export default __webpack_public_path__ + "static/media/TowerOfLondon.a7ea1efb017fa2866a3d02fff56be9ed.svg";
export { ForwardRef as ReactComponent };